<template>
  <Tabs :value="tabs"></Tabs>
</template>

<script>
import Tabs from '@/components/Tabs'

export default {
  name: 'ListTabs',
  components: {
    Tabs
  },
  computed: {
    tabs () {
      return [
        {
          label: this.$t('listTabs.allClients'),
          routerLink: {
            name: 'list',
            params: this.$route.params
          }
        },
        {
          label: this.$t('listTabs.corruption'),
          routerLink: {
            name: 'list',
            params: this.$route.params,
            query: {
              ...this.$route.query,
              category: 'corruption'
            }
          }
        },
        {
          label: this.$t('listTabs.embezzlement'),
          routerLink: {
            name: 'list',
            params: this.$route.params,
            query: {
              ...this.$route.query,
              category: 'embezzlement'
            }
          }
        },
        {
          label: this.$t('listTabs.sanctionsEvasion'),
          routerLink: {
            name: 'list',
            params: this.$route.params,
            query: {
              ...this.$route.query,
              category: 'sanctions evasion'
            }
          }
        },
        {
          label: this.$t('listTabs.fraud'),
          routerLink: {
            name: 'list',
            params: this.$route.params,
            query: {
              ...this.$route.query,
              category: 'fraud'
            }
          }
        },
      ]
    }
  }
}
</script>
